import React from "react";
import { Loader } from "@monorepo/components";
import { useLegalPolicyQuery } from "@monorepo/services/api/misc";
import theme from "@monorepo/styles/theme";
import { Typography } from "@mui/material";
import DOMPurify from "dompurify";

import { PageWrapper } from "components/Services/ServicesPage";

interface ILegalAgreements {}

const LegalAgreements: React.FC<ILegalAgreements> = () => {
  const { data: policy, isLoading } = useLegalPolicyQuery(undefined as void);

  return (
    <PageWrapper>
      {isLoading && <Loader />}
      {
        <Typography
          sx={{
            paddingLeft: {
              md: theme.spacing(5),
              xl: 0,
            },
            paddingRight: {
              md: theme.spacing(5),
              xl: theme.spacing(10),
            },
          }}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(policy?.content!, { USE_PROFILES: { html: true } }) }}
        />
      }
    </PageWrapper>
  );
};

export default LegalAgreements;
